var _defs, _polygon, _path, _path2, _path3, _path4, _path5, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg17Filled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\xCD_\\xE3_1",
    "data-name": "\\xCD\\xBC\\xB2\\xE3_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 317.24 634.18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:#c8da2e;}.cls-2,.cls-3{stroke:#63676a;stroke-linecap:round;stroke-linejoin:round;stroke-width:6.5px;}.cls-3{fill:none;}.cls-4{font-size:80px;fill:#63676a;font-family:Arial-BoldMT, Arial;font-weight:700;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "138.9 218.15 105.81 47.72 140.31 34.34 200.17 156.88 195.95 220.26 138.9 218.15"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M134.21,34.87c15.07-27.12,35.67-25.11,39,12.39,1.61,18.08,6.35,63.62,17.13,95"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M158.62,464.12c26.61,0,95.81,34.86,135.78-8.7,32-34.9,20.2-118.85-2.76-175.35-8.54-21-7-41-6.68-63.71C286.64,108.59,265,9,228.2,8.93c-25.23,0-19.48,157.27-67,173-19.37,6.4-27.78-43.18-30.55-93-2.43-43.77,10.94-69.13,1.22-81.45C122.77-4.16,88.73,6.17,62,67.56c-16.43,37.72-28.33,87-29.71,148.8-.5,22.68,1.86,42.69-6.68,63.71-23,56.5-34.78,140.45-2.76,175.35C62.81,499,132,464.12,158.62,464.12Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M156.68,388.61c-3.61,19.62-8.9,26.28-18.89,27.95-30.32,5.07-54.37,16.11-77.41-.69"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M143.91,439.15c4.1-3.16,8-10.2,10.85-14.95,3.94-6.65,9-9,16.59-8.35,27.32,2.48,39.64,20.24,66.29,13.71"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M65.88,265.08c50.7-18.48,161-23,191,1.91"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(111.1 606.49)"
  }, "17")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg17Filled);
export default __webpack_public_path__ + "static/media/17_filled.2996a08c.svg";
export { ForwardRef as ReactComponent };